import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export enum TagVariant {
  BLUE = 'blue',
  GRAY = 'gray',
  GREEN = 'green',
  RED = 'red',
}

const tagVariantCSS: Record<TagVariant, string> = {
  [TagVariant.GREEN]: 'border-forest-200 bg-forest-50 text-forest-600',
  [TagVariant.BLUE]: 'border-brand-200 bg-brand-50 text-brand-700',
  [TagVariant.RED]: 'border-fireside-200 bg-fireside-50 text-fireside-600',
  [TagVariant.GRAY]: 'border-gray-100 bg-gray-100 text-gray-500',
};

export type TagProps = {
  className?: string;
  title: ReactNode | string;
  variant: TagVariant;
} & Optional<{
  borderColor: string;
}>;

export const Tag: FC<TagProps> = ({ title, variant, borderColor, className }) => {
  return (
    <span
      className={twMerge(
        'inline-flex h-fit w-fit shrink-0 items-center whitespace-nowrap rounded-2xl px-2 py-[2px] !text-label-md !font-medium',
        tagVariantCSS[variant],
        borderColor && 'border',
        borderColor,
        className,
      )}
    >
      {title}
    </span>
  );
};
